<script lang="ts" setup>
const props = defineProps<{
  resourceType?: number
  resourceId?: number
  to?: string
  primary?: boolean
  link?: boolean
  disabled?: boolean
  block?: boolean
  size?: string
  nested?: boolean
  self?: boolean
  /** a链接友链会分权重，改为click事件响应 */
  hide?: boolean
  noseo?: boolean
  title?: string
  prefetch?: boolean
}>()

const url: {
  [key: number]: string
} = {
  [ResourceTypeEnum.Article]: `/article/${props.resourceId}`,
  [ResourceTypeEnum.Video]: `/video/${props.resourceId}`,
  [ResourceTypeEnum.Feed]: `/feed/${props.resourceId}`
}

const href = props.to || url[props.resourceType!] || ''
</script>

<template>
  <NuxtLink
    v-if="!nested && !hide"
    :no-prefetch="!prefetch"
    :to="href"
    :title="title"
    class="m-link"
    :class="{ primary, link, disabled, block, notlink: !link }"
    :style="{
      fontSize: size ? size : 'inherit'
    }"
    :target="self ? '_self' : '_blank'"
    :rel="noseo ? 'noopener noreferrer nofollow' : 'noopener noreferrer'"
  >
    <slot />
  </NuxtLink>
  <span
    v-else
    class="m-link"
    :class="{ primary, link, disabled, block }"
    :style="{
      fontSize: size ? size : 'inherit'
    }"
    @click="self ? navigateTo(href) : open(href)"
  >
    <slot />
  </span>
</template>

<style lang="scss" scoped>
.m-link {
  text-decoration: none;
  color: var(--text);
  cursor: pointer;
}
.primary {
  color: var(--color-blue-600);
}
.link {
  display: inline;
}
.notlink {
  &:hover {
    text-decoration: none;
    color: var(--text);
  }
  &:active {
    color: var(--text);
  }
}
.block {
  display: block;
}
.link:hover {
  color: var(--color-blue-400);
}
.disabled {
  pointer-events: none;
}
</style>
